// eslint-disable-next-line no-unused-vars
import { Message } from '../entities/Message';
// eslint-disable-next-line no-unused-vars
import { Conversation } from '../entities/Conversation';
// eslint-disable-next-line no-unused-vars
import { ChatUser } from '../entities/ChatUser';

class ChatRepository {
    /**
     * Retrieves a list of conversations for a given user.
     * @param {string} userId
     * @returns {Promise<Conversation[]>}
     */
    async getConversations(userId) {
        throw new Error('Method not implemented.');
    }

    /**
     * Retrieves messages for a specific conversation in real-time.
     * @param {string} conversationId
     * @param {function(Message[]): void} onMessagesUpdate - Callback for real-time updates.
     * @returns {function(): void} - Unsubscribe function.
     */
    onMessagesUpdate(conversationId, onMessagesUpdate) {
        throw new Error('Method not implemented.');
    }

    /**
     * Sends a new message to a conversation.
     * @param {string} conversationId
     * @param {string} senderId
     * @param {string} senderName
     * @param {string} messageText
     * @param {string} type - 'text' or 'image'
     * @param {File} [imageFile] - The image file to upload if type is 'image'.
     * @returns {Promise<Message>}
     */
    async sendMessage(conversationId, senderId, senderName, messageText, type, imageFile) {
        throw new Error('Method not implemented.');
    }

    /**
     * Creates a new one-to-one conversation or returns an existing one.
     * @param {string} currentUserId
     * @param {string} currentUserName
     * @param {string} otherUserId
     * @param {string} otherUserName
     * @returns {Promise<Conversation>}
     */
    async getOrCreateOneToOneConversation(currentUserId, currentUserName, otherUserId, otherUserName) {
        throw new Error('Method not implemented.');
    }

    /**
     * Creates a new group conversation.
     * @param {string} groupName
     * @param {string[]} participantIds
     * @param {string[]} participantNames
     * @param {string[]} adminIds
     * @returns {Promise<Conversation>}
     */
    async createGroupConversation(groupName, participantIds, participantNames, adminIds) {
        throw new Error('Method not implemented.');
    }

    /**
     * Edits an existing message.
     * @param {string} conversationId
     * @param {string} messageId
     * @param {string} newText
     * @returns {Promise<void>}
     */
    async editMessage(conversationId, messageId, newText) {
        throw new Error('Method not implemented.');
    }

    /**
     * Deletes a message.
     * @param {string} conversationId
     * @param {string} messageId
     * @returns {Promise<void>}
     */
    async deleteMessage(conversationId, messageId) {
        throw new Error('Method not implemented.');
    }

    /**
     * Retrieves a chat user by their UID.
     * @param {string} uid
     * @returns {Promise<ChatUser>}
     */
    async getChatUser(uid) {
        throw new Error('Method not implemented.');
    }

    /**
     * Retrieves a chat user by their email.
     * @param {string} email
     * @returns {Promise<ChatUser>}
     */
    async getChatUserByEmail(email) {
        throw new Error('Method not implemented.');
    }

    /**
     * Retrieves a conversation by its ID.
     * @param {string} conversationId
     * @returns {Promise<Conversation>}
     */
    async getConversationById(conversationId) {
        throw new Error('Method not implemented.');
    }
}

export default ChatRepository;
